import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-national-quesadilla-day',
  templateUrl: './national-quesadilla-day.component.html',
  styleUrls: ['./national-quesadilla-day.component.scss']
})
export class NationalQuesadillaDayComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/national-quesadilla-day/national-quesadilla-day.component.ts